import ScenariosConvertionPanel from "../components/convert-panel";
import SiteMenu from "../components/menu";

export default function ConvertPage() {
    return <>
        <SiteMenu />
        <ScenariosConvertionPanel />
    </>
}
